import React from "react";
import { Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { SectionHeader, FadeUp, Marquee } from "../components/primitives";
import { LeadForm } from "../components/LeadForm";
import { useLang } from "../i18n";

const ForBrands = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden">
      <PageHero over={t.brands.heroOver} title={t.brands.heroTitle} sub={t.brands.heroSub} />

      <section className="py-24 md:py-32 bg-white">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10">
          <SectionHeader over={t.brands.whyOver} title={t.brands.whyTitle} />
          <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {t.brands.why.map((w, i) => (
              <FadeUp key={i} delay={(i % 3) * 0.08}>
                <div className="group bg-wanm-offwhite rounded-2xl p-8 h-full hover:bg-wanm-dark hover:text-white transition-all duration-400" data-testid={`brand-why-${i}`}>
                  <div className="w-11 h-11 rounded-full wanm-gradient-bg flex items-center justify-center mb-5">
                    <Check className="text-white" size={20} />
                  </div>
                  <h3 className="text-xl font-black">{w}</h3>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <Marquee words="TURN PERFORMANCE INTO GROWTH" />

      <section className="py-24 md:py-32 bg-wanm-offwhite">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10">
          <SectionHeader over={t.brands.procOver} title={t.home.howTitle} />
          <div className="mt-16 grid md:grid-cols-5 gap-4">
            {t.steps.map((s, i) => (
              <FadeUp key={i} delay={i * 0.07}>
                <div className="bg-white rounded-2xl p-7 h-full border-t-4 border-transparent hover:border-wanm-pink transition-all">
                  <span className="text-4xl font-black wanm-gradient-text">{s.n}</span>
                  <h3 className="mt-4 text-lg font-black text-wanm-dark">{s.t}</h3>
                  <p className="mt-2 text-sm text-wanm-dark/60">{s.d}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white" id="form">
        <div className="mx-auto max-w-4xl px-5 md:px-10">
          <SectionHeader over={t.brands.formOver} title={t.brands.formTitle} align="center" />
          <div className="mt-14">
            <LeadForm endpoint="/leads/brand" testId="brand-form" submitLabel={t.cta.launch}
              fields={[
                { id: "name", required: true }, { id: "company", required: true },
                { id: "email", type: "email", required: true }, { id: "website" },
                { id: "industry" }, { id: "budget" }, { id: "objective" },
                { id: "message", textarea: true },
              ]} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForBrands;
